
import { ACCOUNT_APP_LICENSES, ACCOUNT_APP_LICENSES_DATA, ACCOUNT_APP_LICENSE_MESSAGE, ACCOUNT_APP_LICENSE_PURCHASES, HIDE_LOADING, SAVED_ACCOUNT_APP_LICENSES_DATA, SET_ADD_EDIT, SHOW_LOADING } from "redux/constants/accountAppLicense";
  
  const initState = {
    loading: true,
    accountAppLicenses: [],
    accountAppLicensesPurchases:[],
    accountAppLicense: {},
    message: "",
    back:false,
    showMessage: false,
    redirect: "",
    allowRedirect: false,
    status: 0,
    addEditValue: false,
    permissions : localStorage.getItem("permissions")!==""?JSON.parse(localStorage.getItem("permissions")):"",
  };
  
  const licensePricing = (state = initState, action) => {
    switch (action?.type) {
      case ACCOUNT_APP_LICENSES:
        return {
          ...state,
          accountAppLicenses: action.accountAppLicenses,
          allowRedirect: false,
          loading: false,
          message: "",
        };
      case ACCOUNT_APP_LICENSES_DATA:
        return {
          ...state,
          accountAppLicensesData: action.accountAppLicensesData,
          allowRedirect: false,
          loading: false,
          message: "",
        }
        case SAVED_ACCOUNT_APP_LICENSES_DATA:
          return {
            ...state,
            accountAppLicensesData: action.accountAppLicensesData,
            allowRedirect: false,
            loading: false,
            subscribed:true,
            message: "",
          }
        case ACCOUNT_APP_LICENSE_PURCHASES:
          return {
            ...state,
            accountAppLicensesPurchases: action.accountAppLicensesPurchases,
            allowRedirect: false,
            loading: false,
            message: "",
          };
      case ACCOUNT_APP_LICENSE_MESSAGE:
        return {
          ...state,
          message: messageRead(action),
          status: action?.response?.status,
          showMessage: true,
          loading: false,
        };
  
      case SHOW_LOADING: {
        return {
          ...state,
          loading: true,
        };
      }
      case HIDE_LOADING: {
        return {
          ...state,
          loading: false,
        };
      }
      case SET_ADD_EDIT:
        return {
          ...state,
          addEditValue: action.addEditValue,
          loading: false,
          appRolePermissions: [],
        };
      default:
        return state;
    }
  };
  
  const messageRead=(action)=>{
    if(action?.response?.status===401 || action?.response?.response?.status){
      return "Unauthorized"
    }
      if(action?.response && action?.response?.response && action?.response?.response?.data && action?.response?.response?.message){
       return action?.response?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.message){
          return action?.response?.data?.message;
      }else if(action?.response && action?.response?.data && action?.response?.data?.message){
          return action?.response?.data?.message;
      }else if(action?.data?.message){
          return action?.data?.message;
      }else if(action?.data){
          return action?.data;
      }else{
          return "something went wrong"
      }
  }
  
  export default licensePricing;
  